import {memo} from 'react';

export const SmileyEmoji = memo(() => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false">
    <circle cx="9" cy="9" r="7.5" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="6.25" cy="7" r="0.85" fill="currentColor" />
    <circle cx="11.75" cy="7" r="0.85" fill="currentColor" />
    <path
      d="M5.75 10.25C6.45 11.65 7.5 12.35 9 12.35C10.5 12.35 11.55 11.65 12.25 10.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
));
